import { render, staticRenderFns } from "./InspectComponent.vue?vue&type=template&id=1535b432&scoped=true&"
import script from "./InspectComponent.vue?vue&type=script&lang=js&"
export * from "./InspectComponent.vue?vue&type=script&lang=js&"
import style0 from "./InspectComponent.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./InspectComponent.vue?vue&type=style&index=1&id=1535b432&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1535b432",
  null
  
)

export default component.exports